import * as ko from "knockout";
import entityBase from 'entityBase';

export class action_code extends entityBase {

    code_no: KnockoutObservable<string>;
    task_id: KnockoutObservable<string>;
    saved: KnockoutComputed<boolean>;

    constructor(item: any) {
        super();

        this.code_no = ko.observable(item.code_no);
        this.task_id = ko.observable(item.task_id);
        this.saved = ko.pureComputed(() => {
            return this.task_id() != null;
        });
    }
}